import 'components/newAccountSteps/profileSteps/profileStep3/BoxTabs/onboarding_BoxTabs.scss';
import 'sass/blocks/identity/_videocall-identification.scss';
import FeatureTogglingRender from 'components/featureToggling/featureTogglingRender';
import {
    VIDEO_CALL_INDEX,
    VIDEO_CALL_URL,
    VIDEO_SELFIE_INDEX,
    VIDEO_SELFIE_URL,
} from 'components/newIdentifyMethods/video/constants';
import VideoContent from 'components/newIdentifyMethods/video/VideoContent';
import VideoDocumentsRequired from 'components/newIdentifyMethods/video/VideoDocumentsRequired';
import { VideoTabbedBox } from 'components/newIdentifyMethods/video/VideoTabbedBox';

import {
    ROBO_VIDEOCALL,
    ROBO_VIDEOS,
    ROBO_VIDEOSELFIE,
    TC_VIDEOCALL,
    TC_VIDEOS,
    TC_VIDEOSELFIE,
    VIDEOCALL,
    VIDEOCALLS_IN_1_BOX,
    VIDEOSELFIE,
} from 'constants/featureFlagging';
import { VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';
import { CREDIT_CARD, ROBO, ROBO_REJECTED, TRADITIONAL } from 'constants/userProfile';
import { FormattedText } from 'core/i18n';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { bindActionCreators } from 'redux';
import { showDependsOnTwoFlags } from 'utilities/flags';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import { useUpdateUserProfileOnVideoOptionChange } from 'components/newIdentifyMethods/video/hooks/useUpdateUserProfileOnVideoOptionChange';
import { useDoTagging } from 'components/newIdentifyMethods/video/hooks/useDoTagging';

export const Video = ({
    flags,
    formActions: { change, resetValidity },
    isIbanActive,
    storage,
    type,
    userProfile: { investmentType, selectedItemIndex, videoSelected, docNumber, userId, recordId },
    withTabs,
}) => {
    useUpdateUserProfileOnVideoOptionChange({
        flags,
        withTabs,
        type,
        videoSelected,
        investmentType,
        change,
        resetValidity,
    });
    const { checkBowserTagError } = useDoTagging({
        flags,
        docNumber,
        recordId,
        userId,
        investmentType,
        type,
        withTabs,
    });

    const onTabChange = selectedItemIndex => {
        change('userProfile.agreeVideoCallClauseCheck', false);
        change('userProfile.videoCallClause', false);
        const videoSelected = selectedItemIndex === VIDEO_CALL_INDEX ? VIDEO_CALL : VIDEO_SELFIE;
        const videoUrlSelected = selectedItemIndex === VIDEO_CALL_INDEX ? VIDEO_CALL_URL : VIDEO_SELFIE_URL;
        change('userProfile.selectedItemIndex', selectedItemIndex);
        change('userProfile.videoSelected', videoSelected);
        change('userProfile.videoUrlSelected', videoUrlSelected);

        checkBowserTagError(videoSelected);
    };

    const withTabsCols = withTabs && type === VIDEO_CALL ? '6' : '12';

    const allowedVideoFlags = {
        [CREDIT_CARD]: {
            boxAndFlags: [TC_VIDEOSELFIE, TC_VIDEOCALL],
            tabs: flags?.get(TC_VIDEOS),
        },
        [ROBO]: {
            boxAndFlags: [ROBO_VIDEOSELFIE, ROBO_VIDEOCALL],
            tabs: flags?.get(ROBO_VIDEOS),
        },
        [ROBO_REJECTED]: {
            boxAndFlags: [VIDEOSELFIE, VIDEOCALL],
            tabs: flags?.get(VIDEOCALLS_IN_1_BOX),
        },

        [TRADITIONAL]: {
            boxAndFlags: [VIDEOSELFIE, VIDEOCALL],
            tabs: flags?.get(VIDEOCALLS_IN_1_BOX),
        },
    };

    const allowedVideoMethods = allowedVideoFlags[investmentType];

    let videoMappedFlagsAndContent = {
        boxSelection: allowedVideoMethods.boxAndFlags,
        twoFlags: allowedVideoMethods.boxAndFlags,
        tabs: allowedVideoMethods.tabs,
    };

    if (!allowedVideoMethods) {
        videoMappedFlagsAndContent = {
            boxSelection: allowedVideoFlags[TRADITIONAL].boxAndFlags,
            twoFlags: allowedVideoFlags[TRADITIONAL].boxAndFlags,
            tabs: allowedVideoFlags[TRADITIONAL].tabs,
        };
    }

    return (
        <div className="video-container">
            <ConditionalToggling condition={withTabs && videoMappedFlagsAndContent.tabs}>
                <FeatureTogglingRender
                    productKeyFilter="every"
                    notAllowedProductKey={[...videoMappedFlagsAndContent.boxSelection]}
                >
                    <header>
                        <p className="font-heading6">
                            <FormattedText value="identification-headerChooseMethods" />
                        </p>
                    </header>
                    <VideoTabbedBox handleTabChange={onTabChange} selectedItemIndex={selectedItemIndex} />
                </FeatureTogglingRender>
            </ConditionalToggling>
            <div className="row">
                <FeatureTogglingRender
                    notAllowedProductKey={flags =>
                        showDependsOnTwoFlags(
                            flags,
                            videoMappedFlagsAndContent.twoFlags[VIDEO_CALL_INDEX],
                            videoMappedFlagsAndContent.twoFlags[VIDEO_SELFIE_INDEX]
                        )
                    }
                >
                    <div className={`col-xs-12 col-sm-${withTabsCols} video-description`}>
                        <p className="font-heading6">
                            <FormattedText value="identification-videoCallOption" />
                        </p>
                    </div>
                </FeatureTogglingRender>
                <div className={`col-xs-12 col-sm-${withTabsCols}`}>
                    <VideoDocumentsRequired withTabs={withTabs} />
                </div>
            </div>
            <VideoContent storage={storage} isIbanActive={isIbanActive} />
        </div>
    );
};

export default connect(
    state => ({ userProfile: state.userProfile }),
    dispatch => ({ formActions: bindActionCreators(actions, dispatch) })
)(withFeatureToggling(Video));
